module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/white-0.2-45fe205727a4ac875f5dd97d3deba1cc.png";